import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Footer extends Component {
  constructor() {
    super()
    this.state = {}
  }
  render() {

    return (
      <div className="footer container footer-container">
        <br />
        <hr />
        © {new Date().getFullYear()} by <Link to="/">Envelope.li</Link>
        <span className="footerlink"><Link to="/termsconditions">Terms & Conditions</Link></span>
        <span className="footerlink"><Link to="/privacypolicy">Privacy Policy</Link></span>
        <span className="footerlink"><Link to="/about">About</Link></span>
        <span className="footerlink"><a href="mailto:info@envelope.li?Subject=Request%20for%20Information" target="_top"> Contact </a></span>
        <br />
        <br />
      </div>
    )
  }
}
 // - made with ❤️ &nbsp; & 😃 &nbsp by Envelope; -
export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.js